import React from 'react';
import { ReactComponent as BellIcon } from 'assets/icons/BellIcon.svg';
import { ReactComponent as PillIcon } from 'assets/icons/PillIcon.svg';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { TaskCard, TaskCardProps } from '../TaskCard/TaskCard';
import { SvgIcon } from '../SvgIcon/SvgIcon';

interface ReminderTaskCardProps extends Omit<TaskCardProps, 'taskTypeLabel' | 'icon'> {
  variant: 'health' | 'medication';
  instruction: string;
}

export const ReminderTaskCard = ({
  variant,
  instruction,
  isCompleted,
  onClick,
}: ReminderTaskCardProps) => {
  const { translation } = useTranslationContext();
  const IconComponent = variant === 'health' ? BellIcon : PillIcon;
  const taskTypeLabel =
    variant === 'health'
      ? translation('checklist_task_type_reminder')
      : translation('checklist_task_type_medication');
  return (
    <TaskCard
      icon={<SvgIcon component={IconComponent} />}
      taskTypeLabel={taskTypeLabel}
      taskName={instruction}
      isCompleted={isCompleted}
      onClick={onClick}
    />
  );
};
